(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    toggleSticky(elements, isSticky) {
      elements.forEach(el => {
        el.classList.toggle('sticky', isSticky);
      });
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // The utility strip is a section of its own, so it cannot sit inside the
      // header's sticky wrapper. When the merchant opts in, its wrapper is
      // given the same state classes as the header and the two travel as one.
      this.stickyStrip = null;
      const optedInStrip = document.querySelector('[data-sticky-with-header]');
      if (optedInStrip) {
        this.stickyStrip = optedInStrip.closest('.shopify-section');
      }
      if (this.stickyStrip) {
        this.stickyStrip.classList.add('kf-sticky-strip');
        this.onResizeHandler = this.measureStrip.bind(this);
        window.addEventListener('resize', this.onResizeHandler);
        this.measureStrip();
      }
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.filterActions = document.querySelectorAll('.ss-actions');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onResizeHandler) window.removeEventListener('resize', this.onResizeHandler);
    }

    // With the strip pinned at the top, the header has to start below it.
    // Measured rather than hardcoded so the offset survives a copy change that
    // wraps the strip onto a second line.
    measureStrip() {
      document.documentElement.style.setProperty(
        '--kf-sticky-strip-height',
        `${this.stickyStrip.offsetHeight}px`
      );
    }

    // The header, plus the strip when it has opted in.
    get stateTargets() {
      return this.stickyStrip ? [this.header, this.stickyStrip] : [this.header];
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.stateTargets.forEach(el => {
        el.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      });
      this.toggleSticky(this.filterActions, false)
      
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.stateTargets.forEach(el => {
        el.classList.add('shopify-section-header-sticky', 'animate');
        el.classList.remove('shopify-section-header-hidden');
      });
      this.toggleSticky(this.filterActions, true)
    }

    reset() {
      this.stateTargets.forEach(el => {
        el.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      });
      this.toggleSticky(this.filterActions, false)
    }

    // Repointed from v1's <header-menu> custom element to v2's native
    // <details>. Sticky used to be off, so a panel open while the header slid
    // away was not reachable; now it is.
    closeMenuDisclosure() {
      document.querySelectorAll('.mega-v2__disclosure[open]').forEach(disclosure => {
        disclosure.open = false;
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
